import qt_storage from '@libs/qt/storage';

export default {
    data() {
        return {}
	},
	computed:{
		autoHeightStyle:function(){
			return{
				minHeight:this.$store.state.indexConH+'px',
			}
		},
		scrollHeightStyle:function(){
			return{
				'overflow-y':'auto',
				height:this.$store.state.indexConH+'px'
			}
		}
	},
    methods: {
		setMainMenuIndex:function(index){
			//设置菜单index
			this.$store.commit('setMainMenuIndex',index);
		},
		setSubMenuIndex:function(index){
			//设置菜单index
			this.$store.commit('setSubMenuIndex',index);
		},

        //废弃方法，不再支持，不再调用，后续清空
		initOwnAuthority:function(){
            //editby mxj@20220419 下面全部注释
			// var value = qt_storage.sessionGet('current_school');
			// if(value){
			// 	value = JSON.parse(value)
			// 	//设置菜单index
			// 	this.$store.commit('setOwnAuthority',value.authority);
			// }
		}
    },
	filters : {
	
	}
}


// WEBPACK FOOTER //
// ./src/components/mixins/page.js